import BaseUseCase from "../../../base_use_case.js";

class UpdateUserUseCase extends BaseUseCase {

  execute(identifier, params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "put",
      url: `/api/v1/admin/users/users/${identifier}`,
      data: this.wrapParams(params, "user"),
    });
  }
}

const instance = new UpdateUserUseCase();
export default instance;